var _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g3, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _polygon, _polygon2, _path56, _g4, _path57, _rect, _path58, _path59, _g5, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagIt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u043B\\u043E\\u0439_1",
    "data-name": "\\u2018\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2507.79 1568.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2627.1,1780.77c-143.42,0-2232.69.52-2233.9-3.22l-.2-.48a2.47,2.47,0,0,1-.21-.69c-.79-1.87-321.91-527.13,177.3-892.78,195.33-143.07-12.22-237.52,143.1-396.79,178.5-183,373.31,19.45,571.8-63.55,35.07-14.65,70.26-38.23,105.49-74.42a392.62,392.62,0,0,1,64.83-53.51q5.36-3.54,10.81-6.91a432.6,432.6,0,0,1,43.26-23.34q15-7,30.55-13h0a501.74,501.74,0,0,1,50.63-16.39A575.27,575.27,0,0,1,1666.07,221q16.85-2.18,34-3.44c221.79-16.58,471.38,76.66,600.19,212.93,25.93,27.45,143.85,169.43,50.9,364.59-58.7,123.22,187.17,240.91,274.54,381.61C2847.79,1534.39,2629.12,1776.11,2627.1,1780.77Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#426de1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.66,1777.48h94.51c5.06-4.3-3.5-14.06-12.46-14.71-3.89-.3-8.8.52-14.42,1.7-1.3-17.27-8.73-94.92-36.72-91.8-31.47,3.49,0,34.2,8.9,52.37,6.59,13.47,13.54,32.78,16.72,41.89-2.56.55-5.2,1.09-7.91,1.59-4.17-12.81-19.69-55.89-39.43-53.38-23.17,2.94-13.85,20.21,2.57,30.47,12.05,7.54,26.85,18.25,33.88,23.43a100.32,100.32,0,0,1-18.48,1.48C495.63,1770.14,487.73,1774.91,484.66,1777.48Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1302,933.76s-23.53-197.1-124.53-314.71c-13.42-15.63-39.11-5.68-38.67,14.92,0,.34,0,.69,0,1C1140.11,670.17,1253.19,818.47,1302,933.76Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aec3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314.25,990.18s-100.64-246.34-272.53-355.29c-10.48-6.65-24.68-4.24-31.71,6-4.57,6.66-6.63,17.07-1.49,33.32C1022.21,717.52,1213.92,863.37,1314.25,990.18Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aec3ff",
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1339.33,1412.83s14.44-120.95,76.42-193.13c8.23-9.6,24-3.49,23.73,9.15,0,.21,0,.43,0,.64C1438.66,1251.07,1369.27,1342.08,1339.33,1412.83Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aec3ff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.79,1447.46s61.76-151.18,167.25-218a14.35,14.35,0,0,1,19.46,3.67c2.81,4.09,4.07,10.48.92,20.45C1511,1280.13,1393.36,1369.64,1331.79,1447.46Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aec3ff",
    opacity: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.15,1294.13s55.85,153.29,26.68,161.92-49.91-175.3-49.91-175.3-158.68-46.5-215.46-31.42c0,0,116.65,139.46,86.25,140.64S753.2,1251.68,753.2,1251.68s-155.35-3.08-164.83,90.24,37,131.55,60.22,133.46,166.26-23.57,165.6-4.34-92.53,64.94-149.26,57.08c0,0,83.78,137.23,160.72,116.9s93.17-72.7,140.94-84.39,85.29-4.49,63.24,12.52-105.38,21.75-139,61.42-61.91,66.19,13.16,68.28c205.46,5.72,237.5-148.1,237.5-148.1s126.71-101.16,44.09-196.52C1185.59,1358.23,1122.75,1301.68,1064.15,1294.13Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aec3ff",
    opacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2147.72,1311.15c52.77-42.12-9.66-134.92-9.66-134.92s-134.35-23.15-145.48-42,118.72-2.64,118.72-2.64c-13-40.23-103-118.12-103-118.12s-119.38,59.16-125.53,38.15,108.38-47,108.38-47c-27.41-32.51-86.14-48.49-86.14-48.49-89.91-12.82-101.72,103.3-101.72,103.3s-41.81,19.61-101.74,14.51h0s-11.53-2-29.38-1.41l4.42,10.19c3.09-.35,6.13-.58,9.11-.66h.18c1.88,0,4.55,0,7.82.11h0c7.44.47,12.86.62,16.68.54h0c23.17,1,53.92,3.67,63,10.36a21.85,21.85,0,0,1,3.73-4.21l-3.73,4.21c-29.81,33.64,1.77,123.54,32.8,167.81s35.55,17.14,46.45-18.66-18.73-88.07-17-108,20.68-.09,32.23,33.38-13.82,63.71,3.88,118.19,133.4,51.67,133.4,51.67c-26.87-31.26-35-104.68-23.65-112.57s51.72,88.57,61.94,101.89S2094.94,1353.27,2147.72,1311.15Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aec3ff",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2030.76,625c-16.34-52.91-105.88-33.05-105.88-33.05s-57.92,95.61-75.65,98.46,33.56-91.42,33.56-91.42c-34.61-2.12-121,43.25-121,43.25s9.39,108.85-8.49,107.25-3.4-96.81-3.4-96.81c-33,11.19-62.82,51.23-62.82,51.23-36.72,64.79,48.38,108.59,48.38,108.59s2.44,37.8-19.41,82h0a128.89,128.89,0,0,0-9.87,22l9.1-.32c.66-2.47,1.39-4.85,2.22-7.15,0,0,0,0,0,0l0-.1c.58-1.43,1.4-3.46,2.43-5.94h0c2.59-5.54,4.33-9.63,5.42-12.57v0c7.74-17.38,19-40.06,26.8-45a17.56,17.56,0,0,1-2.1-4.11l2.1,4.11c16.75,32.83,94.83,35.66,137.92,25.24s23.73-22-.33-41-72.84-12.09-87.58-19.37,6.13-15.81,35.14-14.6,44.49,29.63,91.38,32.44,79.41-86.34,79.41-86.34c-31.92,11.14-90.4-4.63-93-15.68s83.1-12.94,96.34-16.75S2047.1,677.85,2030.76,625Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aec3ff",
    opacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.07,499s25.34-47.69,85.93-42.39c0,0,88-79.5,181.79-10.6,0,0,99.72-17.07,173.57,14.78,49.24,21.24,65.51,43.51,65.51,43.51Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f8fcff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1750.71,419.8s18-36.13,60.94-32.12c0,0,62.39-60.22,128.91-8,0,0,70.72-12.93,123.09,11.2,34.92,16.09,46.45,33,46.45,33Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f8fcff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M748.55,874.22s16.21-36.13,55-32.11c0,0,56.25-60.22,116.24-8,0,0,63.76-12.93,111,11.2,31.48,16.08,41.88,33,41.88,33Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f8fcff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.27,1527.89H982.92v-161h167.21l44.9-269.4H1040.21v-161H1222.9l41.81-243.07h165.66l-41.8,243.07h253.91l40.26-243.07H1848.4l-41.8,243.07h137.79v161H1778.73l-44.9,269.4h154.83v161H1706l-43.35,249.27H1497l43.35-249.27H1286.38l-41.8,249.27H1078.91Zm445.9-161,46.44-269.4H1360.7l-46.45,269.4Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f0c25f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M791.44,1215c0-.51,7.37-15.74,5-16.91s-6.54-1-7,1.67S791.44,1215,791.44,1215Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M794.22,1224.09c0-1.5-1.72-24.31-5.57-28.85s-11.71-11-14.18-10.8-12.13,13-9.22,22.88,15.16,23.15,15.16,23.15Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M808.89,1196.45l-22.4,6.72a1.4,1.4,0,0,1-1.75-1l-12.8-42.71a1.41,1.41,0,0,1,.94-1.75l22.4-6.71a1.41,1.41,0,0,1,1.75.94l12.8,42.71A1.41,1.41,0,0,1,808.89,1196.45Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f1a34f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M803.07,1198.2l-20.32,6.09a2.5,2.5,0,0,1-3.1-1.67L767.47,1162a2.5,2.5,0,0,1,1.67-3.11l20.32-6.09a2.49,2.49,0,0,1,3.1,1.68l12.18,40.62A2.51,2.51,0,0,1,803.07,1198.2Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#d86713"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M772.16,1186.1s9.33-14.35,11.61-13.55c3.25,1.14-8.46,19.35-8.46,19.35s8.68-13.61,10-12.58c3.09,2.33-1.82,10.88-6.7,17.43,0,0,8.73-8,9-6.55,1,5-9.58,17.26-9.58,17.26l-5.91-13.5Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M765.17,1199.43c.45-1.76,2.72-36,3.7-32.78s3.29,21.22,3.29,21.22Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M914,1190s-1,37.26-11.72,67.34c-8.49,23.74-23.08,43-48.09,35.89-2.56-.72-5-1.51-7.44-2.35h0c-50.83-17.7-67.27-58.23-67.27-58.23,3.78-6.24,14.75-8.54,14.75-8.54,10.23.55,55.21,19.65,58.08,20.23,10.41,2.09,18.81-55.08,25.57-74.88s34.43-28.67,34.43-28.67Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f99746"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M903.27,1230.48l-1,26.85c-8.49,23.74-23.08,43-48.09,35.89-2.56-.72-5-1.51-7.44-2.35.8.11,16.11,2.18,22.52-4.23,6.58-6.6,5.9-28.44,18-43S903.27,1230.48,903.27,1230.48Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ed7d2b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M904.68,1721.5s12.5,11.42,10.06,19.53-13.73,13.52-15.25,23.43-7.63,15.32-13.12,15.32H860.19s-4-7,5.72-9.08,13.44-13.75,12.83-24.56.92-25.24.92-25.24l20.74-4.8Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#0e2949"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M766.86,1777.71H844a5.58,5.58,0,0,0,5.58-5.42c.13-4.52-.25-11.09-2.75-16.63-4.12-9.12-6.72-10.72,10.66-37.27-5.22,5.39-19.31,2.92-31.2,1.32-1.46,2.37-23.52,36.45-28.39,39.94C792.48,1763.52,768.51,1762.14,766.86,1777.71Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#0e2949"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M887,1350.21s-55.89,105.47-71.08,163.54c-11.79,45.08,60.16,219.49,60.16,219.49s5.88-.39,15.47-4.16c9.42-3.7,13-13.64,13-13.64s-4.27-124.7-18.83-185c-3.27-13.55,15.84-57.23,48.08-81.15s45.68-100.9,26.48-106.11S887,1350.21,887,1350.21Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#707fe5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M934.82,1320.27S876.07,1535.66,858.24,1584s-46.09,151-46.09,151a74.45,74.45,0,0,0,40.76,4.42s85.91-125.87,89.65-181.5c1.73-25.71,88.16-127.65,78.52-194.12Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#8c9df4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.94,1387.48s-12.5,6.3-34.6,8.15h0c-25.3,2.13-63.21-1.6-109.37-27.3,0,0-12.88-10.61,2.94-55.74,12-34.16,17.81-106.18,32.42-171.82,0,0,47.42-14.88,85.46-2,29.06,9.83,26.17,54.44,31.54,100.88.5,4.34,1.07,8.69,1.74,13C1039,1303.5,1020.94,1387.48,1020.94,1387.48Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f99746"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M895.59,1043.6S928,990.92,953,1018c0,0,16.38,4.18,25.77,29.69,9.57,26-5.34,49-15.3,45.3-6.38-2.39-9.37,8.62-9.37,8.62Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M948.05,1013.88s2.22-21.81,34.09-19.69c0,0-15.07.27-18.3,6.55,0,0,10.95-7.06,18.95-3.62s11.38,18.39,11,23.15-6.58,19.64-12,20.41-12.41-3-12.41-3Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M964.1,1137.42c-3-8-7.45-16.36-11-41.83l-1.91.67L919,1107.59s2.26,10.31,3.69,20.12c.59,4,1,11.18,1.29,17.43s6.57,7,13,6.7C953.94,1151.06,963.31,1144.71,964.1,1137.42Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M919,1107.59s2.26,10.31,3.69,20.12c18.46-3.19,25.82-21.5,28.48-31.45Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#e8945b"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M954.06,1092.16s7.5-16.74,7.94-30.2c.31-9.6-9.46-43.63-43.63-33.6a47.79,47.79,0,0,0-18.59,10.26c-6.84,6.21-16.18,18.83.41,47.36l4.65,9.78Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M914.14,1117.78s44-5.6,40-32.91-.86-46.43-29.09-44-32.17,13.61-33.08,23.05S902.61,1118.53,914.14,1117.78Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M905,1043.07s16.62,30.3,35.73,32.39,26.38-4,26.38-4a52.73,52.73,0,0,1-21.51-28.36S911.89,1026.51,905,1043.07Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M908.38,1045.24s-7.93,8.44-9.12,15.71-.1,21.73-4.34,21.84c0,0-12.18-20.47-3.8-34.25C900,1033.92,908.38,1045.24,908.38,1045.24Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M906.87,1046.56s13.39,32.32,38.18,39.71c0,0-26.21-17.26-31.38-39.12S906.87,1046.56,906.87,1046.56Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1020.94,1387.48s-12.5,6.3-34.6,8.15h0s-18.16-22.77,2.11-48.28-1.58-72.6,14-98.21c10.86-17.82,21.43-13.67,26.86-9.51.5,4.34,1.07,8.69,1.74,13C1039,1303.5,1020.94,1387.48,1020.94,1387.48Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ed7d2b"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.67,1349.63s2.69,6.28,6.45,6.7c6.15.68,17.85,5.83,19.69,6.92,5,3,4.64,16.18-.34,17.43s-7.47-9.86-23-12.83c-5.28-1-13,2.64-16.08-10Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M997.76,1138.75c45.25,16.64,46.92,96.8,67.09,132.11,20.81,36.41,41.07,84.33,41.07,84.33s-.37,1.43-8.13,3.65a32.37,32.37,0,0,1-11.16.91s-42.75-38.68-54.37-53.93-39-86-39-86S979.79,1132.14,997.76,1138.75Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f99746"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.48,1361s1.1,5.38,7.77,9.74,12,8.71,12.67,6-3.72-5.61-4.75-10.59S1088.48,1361,1088.48,1361Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "girl_2",
    "data-name": "girl 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1798.18,1306.61a64.48,64.48,0,0,0-57.84,16.51,172.16,172.16,0,0,0-21.06,24.1c-17,23.66,15.5,47.09,11.19,55.1s-14.32,14.35-9.94,31.09,33.23,38.47,42.64,39.43c95.36,9.8,136.74-42.77,104.86-71.11s-18.87-69.45-44.74-85.42A79.53,79.53,0,0,0,1798.18,1306.61Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#162c51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.35,1456.16s-87,42.15-103.32,41.44S1526.84,1461,1526.84,1461l2.55,17.28s77.52,44.58,104.62,47.11c26.68,2.49,117.91-23.94,126.72-29.53S1773.94,1461.81,1748.35,1456.16Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.77,1495.92c7.88,5.47,17.77,10,30.19,12.85,46.53,10.75,64.36-28.58,71.06-55.58a39.92,39.92,0,0,0-15.76-4.84c-3.37-.4-6.9-.66-9.83-.81-5.23-4-13-20.38-14.74-45.81l-2.19.59-36.67,10s1.68,11.66,2.5,22.68c.64,8.62.74,16.86-.89,18.88-2.87.62-4.58,1-4.58,1l0,0A236.82,236.82,0,0,0,1738.77,1495.92Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760.83,1412.36s1.68,11.65,2.5,22.68c20.78-2.08,30.42-21.87,34.17-32.72Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1754.62,1423.3s49.32-2.72,47.15-33.4,2.74-51.71-28.84-51.27-36.86,12.58-38.63,23S1741.74,1423.22,1754.62,1423.3Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1734.54,1344.46c7-9.77,12.85-8.16,16.28-5.61,25.86-16.74,44.78,3.9,44.78,3.9,4.87,21.78,21.65,33.26,21.65,33.26s-8.74,7-29.66,2.35c-26.76-5.93-35.95-29.14-37.2-32.71-2.82,2.92-6.45,4.77-9.24,11.1-3.31,7.51-5.39,11.87-5.44,24.21C1735.71,1381,1724.11,1359.13,1734.54,1344.46Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#162c51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1854.07,1596.19c4.45-22.76,19-113.73,4.45-143-5.21-10.51-25.68-11.46-48.13-10.54-7,4.51-33.61,21.56-44.54,19.43l-.62-.14c-5.15-1.29-7.09-4.91-2.79-8a226.46,226.46,0,0,0-23.67,3.3c-7.8,1.47-29.22,14.61-29.22,14.61s9.71,15.11,25.33,21.72c-2.65,23.76,1.3,34.25,25.95,89.13,20.83,46.4-2.81,88.17-2.81,88.17s122.63,98.6,123.31,48.4C1881.85,1681.44,1848.38,1625.29,1854.07,1596.19Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#8ca0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1751.94,1778.05a22.79,22.79,0,0,1-16.4-10c-.59-.89-1.23-1.84-1.9-2.86-14-21.13-19.39-85.84-50.79-154.79-7.64-16.78-35.1-19.8-42.58-38.77,0,0-18.43-61.5,35.26-63.32s143.79,171.12,145.21,189.26C1822.12,1715.16,1856.24,1789.82,1751.94,1778.05Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#162c4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.55,1777.7H1615s2.85-12.52-2.16-21c-4.44-7.54-2.74-11.83.55-18.06a29.11,29.11,0,0,1-12.87,2.49c-3.81-.23-7.84-2-11.37-4.11-3.29,3.85-17.37,20.24-21.77,23.49C1562.36,1764.16,1540.09,1762.85,1538.55,1777.7Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aa3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1638.52,1526.11c-4.6,34.5-22.57,143.38-54.27,196.5-10.21,17.12,25.75,26.73,26,26.68,4.82-1.27,12.86-9,16.56-12.3,25.73-23.19,78-88.86,78-141.51,0-25.67.45-74.7-18.21-87.16C1675,1500.65,1640.35,1512.41,1638.52,1526.11Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#162c4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.26,1778.13a55.88,55.88,0,0,1-6.33-14.43c-4.11-14.41-5.57-24.9-13.46-47.36-8.29-23.57-18.12-52.57-30.41-82.74-3.79-9.32-7.82-18.74-12.1-28.16-7.65-16.78-28.69-14.46-36.18-33.44,0,0-29.2-65.77,24.49-67.59s155.7,176,161.57,193.18C1883.25,1716.43,1906.32,1796.19,1789.26,1778.13Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.65,1777.7h76.41s2.86-12.52-2.16-21c-4.44-7.54-2.74-11.83.55-18.06a29.08,29.08,0,0,1-12.87,2.49c-3.81-.23-7.83-2-11.36-4.11-3.29,3.85-17.38,20.24-21.78,23.49C1618.45,1764.16,1596.18,1762.85,1594.65,1777.7Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#c1514c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769.47,1716.34c-8.29-23.57-18.12-52.57-30.41-82.74,3.21-22.86,10.13-42.86,21.77-50.93C1760.83,1582.67,1789.07,1670.16,1769.47,1716.34Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.13,1523.67c-4.6,34.49-11.08,145.82-42.78,198.94-10.22,17.12,25.75,26.73,25.94,26.68,4.82-1.27,12.86-9,16.56-12.3,25.74-23.19,78-88.86,78-141.51,0-25.67-30.13-72.64-48.8-85.1C1700.54,1502.71,1685,1510,1683.13,1523.67Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1517.71,1416.56l78.26-8.31a5.05,5.05,0,0,1,5.26,3.22l28,73.57a5.06,5.06,0,0,1-4.52,6.85l-77.65,3.13a5.06,5.06,0,0,1-4.87-3.1l-28.6-68.39A5,5,0,0,1,1517.71,1416.56Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.92,1417.27l78.25-8.31a5.05,5.05,0,0,1,5.26,3.22l28,73.58a5,5,0,0,1-4.52,6.84l-77.65,3.13a5.06,5.06,0,0,1-4.87-3.1l-28.6-68.39A5,5,0,0,1,1510.92,1417.27Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.29,1451.62c-1-2.62.4-4.75,3-4.75a7.52,7.52,0,0,1,6.48,4.75c1,2.63-.39,4.76-3,4.76A7.53,7.53,0,0,1,1554.29,1451.62Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.26,1424.22a1.58,1.58,0,0,1,1.48-2.34,3.71,3.71,0,0,1,3.19,2.34,1.59,1.59,0,0,1-1.49,2.34A3.69,3.69,0,0,1,1513.26,1424.22Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ebf3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1840,1453.19s-108.46,39.94-124.75,39.13c-10.54-.53-98.09-31.31-98.09-31.31l-7.86,14.87s85.22,54.77,108.64,54.5c46.26-.53,124.3-28.92,133.11-34.51S1865.62,1458.84,1840,1453.19Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.18,1461s-7.86-12.09-15.69-12.45-21.34,5.34-26,6.23-17.78,5.15-13.87,11.56,22.06,7.82,29.88,6.4,17.79,3.13,17.79,3.13Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1603.62,1448.93s-12.44-5.71-16-6.77-2.85,0-1.78,3.38,7.47,6.59,7.47,7.65S1603.62,1448.93,1603.62,1448.93Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1519,1454.61s5-16.36,10.41-11.22c5.68,5.35,2.23,10.7,1.54,17.52-1.33,13-4,12.48-5.63,11.89S1517.13,1461.17,1519,1454.61Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.68,1457.1s-2.51,13.92,10.71,21.19l-3.91-9.58Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.39,1405.66s4.66-1.85,17.78-.78c0,0-.7,5.11-10.37,5.62C1747.32,1410.79,1745.39,1405.66,1745.39,1405.66Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1784.14,1472.89s9.7,30.71,43,37.7c0,0,55-16.95,27.62-54.43C1854.78,1456.16,1827.7,1436,1784.14,1472.89Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#8ca0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.68,1459.07s-2.29-7.67-2.42-9,0-2,1.21-1.07,3,3.39,2.44,5.72S1518.68,1459.07,1518.68,1459.07Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1486.26,1082.12a6.39,6.39,0,0,0-1.13,6.82,0,0,0,0,0,0,0c1.65,4.54,7.08,9.62,13.39,14.68.81.66,1.52,1.25,2.15,1.8l.48.43.37.33c5.88,5.43,3.67,6.67,14.24,17.67,12,12.54,20.35,12.77,22.71,11.63,2-1-2.06-7.63-6.56-15.1l-.65-1.09c-.6-1-1.19-2-1.79-3-5.27-9-3.91-13.22-2.67-26.61,1-10.88,16.93-60.79,16.93-60.79l-23.1-4s-7,39.73-14.61,45.85c-4.1,3.27-8.69,3.31-12.63,5.73-.28.16-.55.34-.82.51A30.58,30.58,0,0,0,1486.26,1082.12Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1486.26,1082.12a6.39,6.39,0,0,0-1.13,6.82,0,0,0,0,0,0,0c2,4.54,7.31,9.59,13.41,14.64.8.66,1.5,1.27,2.13,1.84l.48.43.37.33c5.88,5.43,3.67,6.67,14.24,17.67,12,12.54,20.35,12.77,22.71,11.63,2-1-2.06-7.63-6.56-15.1a51.44,51.44,0,0,1-21.48-15.83c-7-8.93-11.74-20.3-16.5-27.28l-1.36-.26A30.58,30.58,0,0,0,1486.26,1082.12Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1672.5,1067.7c1.43,7.13,11.59,5.94,22.94,3.16s8.66.53,24.82-1.26,21-7.82,21.54-10.22c.45-2.13-7.54-2.88-16.1-3.87q-1.62-.18-3.24-.39c-9.67-1.21-16.75-7.45-25.54-12.57-8.32-4.86-20.73-24.63-20.73-24.63l-22.16,1.75s11.63,17.66,16.12,25.34c2.65,4.52,2.51,10.49,2.18,15.11A28.74,28.74,0,0,0,1672.5,1067.7Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1695.44,1070.86c11.36-2.77,8.66.53,24.82-1.26s21-7.82,21.54-10.22c.45-2.13-7.54-2.88-16.1-3.87l-.08.16a45.51,45.51,0,0,1-23.15,7.2c-11,.26-22.57-2.88-30.14-2.75a28.74,28.74,0,0,0,.17,7.58C1673.93,1074.83,1684.09,1073.64,1695.44,1070.86Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.58,926l-20.72,55.74-27,72.79a43.61,43.61,0,0,1-14.36-1.32c-6.48-1.87-13.9-6.76-13.9-6.76s7.51-78.15,21.52-123c3.59-11.52,7.61-20.83,12-26.08C1566.84,871.7,1587.58,926,1587.58,926Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#707fe5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1566.51,837.47c-11.79-3.81-42.56-.06-75.93,6a22.62,22.62,0,0,1-23.37-10.56h0l-84-6.56S1355.5,887.8,1370.68,927c2.23,5.75,7.12,9.34,14.67,9.47h0s50.76.07,67,.07c41.77,0,88.4-28.72,94.43-29.92,9.87-2,13.82,17.77,23.69,38.5s92.81,91.82,92.81,91.82,12.74.13,18-1.85c5.66-2.12,7.74-4.88,7.74-4.88S1597.12,847.34,1566.51,837.47Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#8c9df4"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.28,586.26a29.75,29.75,0,0,0-16-4.17,45.71,45.71,0,0,1-7.75-.47c-32-4.7-51.35,41.86-52.49,55.92-2.07,25.83-15.73,29.77-35,46-38.56,32.43-27.25,70.12-6.17,84.13,12.66,8.4,35,0,35,0,.31.23,61-33.91,90.89-50.38C1511.55,710.86,1476.3,597,1458.28,586.26Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#152949"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1441.65,703.21c.13.09-14.72,5.16-24.65.76-9.34-4.13-16.41-19.49-16.27-19.5,4.25-.2,8.91-3.91,12.5-28.28l1.81.64,30.42,10.95s-2.21,9.76-3.63,19.05C1440.63,694.63,1440,702.11,1441.65,703.21Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1445.46,667.78s-1.21,5.27-3,15.1c-17.47-3.14-25-16.6-27.43-26Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ed975d"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1450,677.47s-41.62-5.59-37.74-31.45,1.12-44,27.85-41.53,30.41,13.11,31.21,22.06S1460.91,678.25,1450,677.47Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1469.8,612.37s-26.64,23-44.77,24.81-25-4-25-4A70.82,70.82,0,0,0,1417.16,610a12.76,12.76,0,0,1,10.51-7.52C1440.61,601.41,1465.14,600.9,1469.8,612.37Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#152949"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1453.14,610.32s8.92,8.61,11.72,15c2.71,6.17,3.52,20.93,1.37,26.78,0,0,13.88-27,6-40.12C1463.91,598.07,1453.14,610.32,1453.14,610.32Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1476.69,764.52c-1.26,84.24-.35,66.64-9.56,74.63-2.22,1.93-8.46,3.07-16.68,3.62-25.83,1.71-71.24-2.54-73-7.32-6-16.52-1.75-21.65-6.72-46.94-.52-2.69-1.16-5.6-1.91-8.77-4.15-17.37-8.18-23.28,6.52-51.18,13.34-25.28,27.19-45.79,28.44-45,35.18,20.88,38,3.33,38,3.33S1477.31,723.43,1476.69,764.52Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1566.86,981.74l-27,72.79a43.61,43.61,0,0,1-14.36-1.32c-6.48-1.87-13.9-6.76-13.9-6.76s7.51-78.15,21.52-123Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#8c9df4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1441.83,686.83s36.2,6.14,40.45,21.73,18.25,110.19,18.25,110.19-10.21,10-18.71,1.47-26.76-88.52-26.76-88.52Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1450.45,842.77c-25.83,1.71-71.24-2.54-73-7.32-6-16.52-1.75-21.65-6.72-46.94l12.46-35.08s-2.06,39.07,9.46,49.34,47.17,19.84,52.77,28.43A31.32,31.32,0,0,1,1450.45,842.77Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#162c4f"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1420.85,826.33s25.49-5.67,29.6-3.41,14.16,10.5,15.42,13.37-9.15-2.18-12.54-3.09c-2.19-.59-8,1.42-10.83,2.37-12,4-19.39,1.95-19.39,1.95Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1403.79,683.49s-34.22,2.11-46.07,18.63c-16.67,23.26-49.75,122.38-30.8,135.59,21.35,14.89,97.17,3.9,97.17,3.9s2.53-11.79-1-17.5-60.56-14.92-63.2-17.55,32.92-51.34,32.92-59.24S1403.79,683.49,1403.79,683.49Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1451.68,830s5.34,6.88,7.09,7.71a5.22,5.22,0,0,0,2.89.61l-3.6-6.47Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1450.45,822.92l15.53,7.54a2.77,2.77,0,0,1-2.58,1c-1.91-.08-6.73-1.85-6.73-1.85Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1345.81 625.03 1183.64 625.03 1183.64 628.61 1344.37 628.61 1345.81 625.03",
    fill: "#f99746"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1221.56 628.61 1344.37 628.61 1381.32 536.75 1258.7 536.75 1221.56 628.61",
    fill: "#f99746"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1550.58,798.29c.93-3.23-.94-5.85-4.17-5.85a8.37,8.37,0,0,0-7.52,5.85c-.93,3.23.94,5.85,4.17,5.85A8.37,8.37,0,0,0,1550.58,798.29Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2417,1115.12c-3.6,9.68-9.83,20.91-16.38,23.7-7.42,3.17-10.52,7.64-10.52,7.64l-6-3.48-7.16-4.16s.17-.79.52-2.09.88-3.08,1.61-5.07a6.94,6.94,0,0,0,.85-6.37c-1.35-3.54-1.08-9,1.22-12.36s4.51-11.55,5.89-11.31c3.35.58-1.64,11.88-.21,14a2.46,2.46,0,0,0,3.22,1.1l.05,0c9.39-4.13,20.78-26.39,25.82-23.38C2417.84,1094.4,2418.56,1111,2417,1115.12Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2384.54,1128.6l11.77,8.27a1.85,1.85,0,0,0,2.57-.45l30.14-42.88a1.87,1.87,0,0,0-.45-2.58l-11.77-8.26a1.84,1.84,0,0,0-2.57.45L2384.1,1126A1.84,1.84,0,0,0,2384.54,1128.6Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2395.31,1136.17l6.9,4.84a1.41,1.41,0,0,0,2-.34l30.64-43.6a1.42,1.42,0,0,0-.34-2l-6.9-4.84a1.41,1.41,0,0,0-2,.34l-30.64,43.6A1.42,1.42,0,0,0,2395.31,1136.17Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2215.79,1067.07s59.85,104.4,81.57,123.61l79.62-59.36s11.56,3.54,16.62,15.14c0,0-48.35,98.51-96,102.69s-114.43-118.08-114.43-118.08Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#707fe5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080.33,1777.16h-34.58c-4.36-2.37-8.24-7.78-9.46-15.85-1.69-11.14-14.18-17.21-16.88-26.33s11.14-21.94,11.14-21.94l2.31-3,2.41-3.1,23,5.41s.57,5.47.91,12.43c.25,5,.38,10.83.1,15.92-.68,12.15,3.4,25.24,14.2,27.61C2081.42,1770.07,2081.06,1774.81,2080.33,1777.16Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#162c4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2281.05,1777.16H2202c-3.8-4.64-2.4-21.77-1.82-27.37.12-1.12.2-1.78.2-1.78s27-21.6,30.72-5.06c.11.52.25,1,.4,1.53,4.67,15.47,25.63,22.5,37.74,24.46C2277.06,1770.22,2280,1774.31,2281.05,1777.16Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#162c4f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266,1335.67s-4.1,51.17-8.93,112.68c-6.55,83.55-14.43,186.18-15.2,205.62-1.35,33.76-6.76,87.76-6.76,87.76s-12.82,12.83-38.48,7.43c0,0-22.86-77.1-29.39-158.66-.11-1.34-.21-2.69-.31-4-6.07-83-15.52-257.89-15.52-257.89Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266,1335.67s-4.1,51.17-8.93,112.68l-89.83,142.15c-.11-1.34-.21-2.69-.31-4-6.07-83-15.52-257.89-15.52-257.89Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2247.25,1341.75s-73.92,185.31-122.53,272.39-63.79,111.39-63.79,111.39-27.85-11.14-30.38-18.73c0,0,18.58-168.12,51.13-209.11,18.4-23.15,40-92.65,41-117s6.58-72.41,6.58-72.41Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f99746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2228.85,1071.61c-28.89,9.11-76.55-16.59-76.55-16.59s24.31-18.89,22.92-60.45l22.33,18,15.17,12.23a181.05,181.05,0,0,1-1.72,19.84c-.44,3.32-1.23,8.5,1.26,11.16A172.4,172.4,0,0,0,2228.85,1071.61Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2212.72,1024.8a181.05,181.05,0,0,1-1.72,19.84c-16.81-2.89-35.88-30.06-35.88-30.06a53.71,53.71,0,0,1,22.43-2Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ed975d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2221.56,1024.11s-47.72,7.93-52.19-21.86-13.66-48.83,16.62-55.15,37.91,4.16,41.83,13.74S2233.85,1021.28,2221.56,1024.11Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2269.16,1339.94a4.68,4.68,0,0,1-3,1.15c-10.85-.14-42.48,5.88-69.25,3.13-22.56-2.17-42.53-8.85-64-18.46-2.85-1.28-9.4-4.78-9.26-8,.1-3.49.45-8.54.88-14.91,1.52-22.14,4.17-60.21,1.59-104.14-.47-8.18-.71-16.29-.74-24.28-.22-59.54,11.58-111.9,35.3-129.63,2-1.45,14.47,4.63,25.9,10.27,10.56,5.21,18.84,5.76,28.82,3.74l12.26,8.85c12.15,11.28,25.46,26.61,31.24,49.9,4.92,19.82,7.81,55.55,9.4,92.58.73,16.78,1.31,33.71,1.46,49.76v.58c.14,1.59.14,3.33.14,4.92C2270.47,1306.66,2269.89,1339.35,2269.16,1339.94Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2124.52,1302.89c1.52-22.14,4.17-60.21,1.59-104.14-.47-8.18-.71-16.29-.74-24.28,9.88-24,18-41.36,18-41.36h24.91S2186.5,1257.84,2124.52,1302.89Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#707fe5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1996.93,1444.25l106.23,15.14a25.46,25.46,0,0,0,28.72-21.56l6.56-46a25.46,25.46,0,0,0-21.55-28.72l-106.23-15.14a25.46,25.46,0,0,0-28.72,21.56l-6.56,46A25.46,25.46,0,0,0,1996.93,1444.25Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122.89,1376.8h0a25.59,25.59,0,0,0-17.6-15.37h0a24.11,24.11,0,0,0-2.45-.47l-21.15-3,1.41-9.94a8.41,8.41,0,0,0-7.14-9.51l-5.52-.79-22.21-3.16-4-.57a8.41,8.41,0,0,0-9.51,7.14l-1.41,9.93-36.52-5.2a25.55,25.55,0,0,0-28.82,21.63L1961.3,1414a25.57,25.57,0,0,0,21.64,28.83L2089,1458a25.1,25.1,0,0,0,5.53.18h0a25.18,25.18,0,0,0,8.27-2.09,25.55,25.55,0,0,0,15-19.73l6.63-46.57A25.28,25.28,0,0,0,2122.89,1376.8Zm-83-35a3.14,3.14,0,0,1,2.61-2.65,3,3,0,0,1,.94,0l4.72.66,17.48,2.5,9.53,1.36a3.14,3.14,0,0,1,2.66,3.55l-1.41,9.93-38-5.41Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2076.39,1305.41s-5,5.1-4.48,12.17c1.29,17.58-.8,25.55-12.11,27.36,0,0-13.42,2.52-13.59-5.36,0,0,6.31.05,5-11-1.53-12.74-1.37-12.86,7-19.51l5.54-9.15Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2063.53,1312.87a81.52,81.52,0,0,0,18.69,1s26.63-82.25,30.05-89.77,79.1-96.45,79.1-96.45l-31.52-78.89s-81.85,136.71-90.15,155.92c-13.74,31.74-18.5,102.91-18.5,102.91A34.18,34.18,0,0,0,2063.53,1312.87Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#8c9df4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2169.33,999.38s4.89-.81,4.1-7.56-.78-15.56,4.71-13.92,5.75,6,8,3.47,2.29-13.36,18.6-14.11,22.95,4.92,30.54,1.59,8-14.82,8-14.82-2.15,4.1-5.41,5.4c0,0,12.66-17.31-2-29.18s-29.6-4.1-38.08-3.59c-18.68,1.13-30.75,2.26-36.86,14.53S2157.34,987.56,2169.33,999.38Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2068.91,1316s5.38,5.6,5.71,7.93c1.09,7.48,3.59,10.71,2.34,11.52-2.6,1.69-6.05-3.85-7.69-8.81S2068.91,1316,2068.91,1316Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ffb27d"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M2452.26,1777.18h-71.21c-3.81-3.24,2.65-10.59,9.39-11.09,2.93-.22,6.64.4,10.87,1.29,1-13,6.58-71.52,27.67-69.17,23.71,2.63,0,25.76-6.71,39.46-5,10.14-10.2,24.69-12.6,31.56q2.89.63,6,1.2c3.14-9.65,14.84-42.11,29.71-40.22,17.46,2.21,10.44,15.23-1.94,23-9.08,5.69-20.23,13.76-25.52,17.66a75.91,75.91,0,0,0,13.92,1.12C2444,1771.65,2450,1775.24,2452.26,1777.18Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1561.55,
    width: 2507.79,
    height: 7.23,
    rx: 2.96,
    fill: "#233862"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2303.35,756.25c-5.2-85.14-64.92-99.33-119.8-99.32S2075,685.42,2077.63,749.45c1.12,27.63,8.84,51.62,27.14,68.63l-20.63,51.63,42-37.36c16.89,8,38.93,12.43,67.28,12.42C2277.51,844.74,2306.7,811,2303.35,756.25Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#abb9ff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M2158.08,778.61h-13.24V763.32h15.88l4.27-25.59h-14.71V722.44h17.35l4-23.09h15.74l-4,23.09h24.11l3.83-23.09H2227l-4,23.09h13.09v15.29h-15.74l-4.26,25.59h14.7v15.29h-17.35l-4.11,23.68h-15.74l4.12-23.68h-24.12l-4,23.68H2154Zm42.35-15.29,4.41-25.59h-24.12l-4.41,25.59Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#ebf3fa"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.82,1005.48c3.53-57.74,44-67.37,81.25-67.36s73.61,19.32,71.84,62.75c-.76,18.74-6,35-18.41,46.54l14,35L773,1057.09c-11.45,5.4-26.4,8.43-45.63,8.43C670.34,1065.5,650.55,1042.63,652.82,1005.48Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#aec3ff"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.19,1768.71l-1.72-.27c-6.77-87.66-33.54-150.56-33.91-151.42l1.56-.68C1207.5,1617.21,1234.46,1680.53,1241.19,1768.71Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1187.39,1608.2c3.31,3.74,18.76,9.75,19.83,8.81s-3-17-6.28-20.76a9,9,0,0,0-13.55,12Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1211.08,1595.16c-3,4-5.69,20.37-4.54,21.22s16-6.42,19-10.42a9,9,0,0,0-14.49-10.8Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1228.86,1612.56c-4.81-1.31-21,2.15-21.4,3.53s11.84,12.59,16.65,13.9a9,9,0,1,0,4.75-17.43Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.9,1634.26c-.48-5-9.47-18.91-10.88-18.77s-7.57,15.54-7.1,20.5a9,9,0,1,0,18-1.73Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1193.3,1633.19c4.42-2.32,13.93-15.91,13.27-17.17s-17.25-1.14-21.67,1.18a9,9,0,0,0,8.4,16Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1203.63,1615.55a3,3,0,1,1,2.47,3.41A3,3,0,0,1,1203.63,1615.55Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f78248"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.09,1641.33c-4.9,6-10.2,31.36-8.48,32.76s25.43-8.95,30.34-15a14.09,14.09,0,0,0-21.86-17.78Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1221,1714.05c5.1,2.49,16.37,17.61,15.66,19.06s-19.56,1.89-24.65-.6a10.27,10.27,0,0,1,9-18.46Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.32,1768.71l2-.31c7.78-100.64,38.51-172.87,38.94-173.85l-1.8-.77C1329,1594.77,1298.05,1667.47,1290.32,1768.71Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1352.08,1584.42c-3.79,4.3-21.53,11.2-22.76,10.12s3.43-19.55,7.22-23.84a10.36,10.36,0,1,1,15.54,13.72Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1324.89,1569.46c3.42,4.59,6.53,23.38,5.22,24.35s-18.43-7.37-21.85-12a10.37,10.37,0,1,1,16.63-12.39Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.47,1589.43c5.53-1.5,24.15,2.47,24.58,4s-13.6,14.46-19.12,16a10.37,10.37,0,1,1-5.46-20Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1317.06,1614.34c.55-5.7,10.87-21.7,12.5-21.55s8.69,17.85,8.14,23.55a10.37,10.37,0,1,1-20.64-2Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1345.3,1613.12c-5.07-2.67-16-18.27-15.23-19.71s19.8-1.32,24.87,1.34a10.37,10.37,0,1,1-9.64,18.37Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1333.44,1592.87a3.41,3.41,0,1,0-2.83,3.91A3.42,3.42,0,0,0,1333.44,1592.87Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#f78248"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.19,1675.36c4,4.9,8.3,25.49,6.9,26.63s-20.68-7.27-24.68-12.18a11.46,11.46,0,0,1,17.78-14.45Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1313.47,1706c-5.85,2.85-18.79,20.21-18,21.88s22.45,2.16,28.3-.69a11.79,11.79,0,1,0-10.33-21.19Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1197.24,1777.16s16.64-18.13,52.45-11.57,55.47-12.67,62,11.57Z",
    transform: "translate(-237.21 -215.61)",
    fill: "#a8d29f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIt);
export default __webpack_public_path__ + "static/media/TagIt.2574d20c9fc6fb32bca0e74bf6a53ad4.svg";
export { ForwardRef as ReactComponent };